import { ReactComponent as LineWidthIcon } from 'assets/icons/line_width.svg';
import { useTranslation } from 'react-i18next';

import { SliderPopover } from '../../ToolbarPopover';

type BorderWidthProps = {
  onChange: (value: number) => void;
  value: number;
};

export const BorderWidthPopover = ({ onChange, value }: BorderWidthProps) => {
  const { t } = useTranslation('editor_toolbar', { useSuspense: false, keyPrefix: 'border' });

  return (
    <SliderPopover
      value={value}
      icon={<LineWidthIcon />}
      label={t('borderWidth.label')}
      onChange={onChange}
      suffix={'px'}
      max={20}
      title={t('borderWidth.title')}
    />
  );
};
